import React,{useEffect,useState} from 'react'

import CommonButton from './SubComponents/CommonButton';
import MediumHeading from './SubComponents/MediumHeading';
const AboutTarbiyah = () => {
    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])
  return (
    <>
        <div className="abouttarbiyahsection" data-aos-delay="400" data-aos="fade-up" data-aos-duration="2000">
        <div className={screenSize.dynamicWidth>=1200 &&screenSize.dynamicWidth <=1399?"myContainerMinimini":screenSize.dynamicWidth>=992 &&screenSize.dynamicWidth<=1199?"myContainer896":"myContainerMini"}>
            <MediumHeading text="About Tarbiyah Institude"/>

            <p>Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. TARBIYAH INSTITUTE is established a clear path for success in this life and the Hereafter by understanding with the aim to spread the Quran and Hadith. TARBIYAH INSTITUTE is well reputed online Islamic Educational Platform where we offer different courses, such as Quranic Arabic, Arabic Grammar, Modern Arabic Language, Skill Development and Parenting Courses for all levels from beginner to advance through the most easy and engaging way by the renowned Islamic scholars worldwide. A Muslim can get a complete guideline to understand the Quran by doing our courses. Everyone can understand the Quran within short time by Joining in our courses. To fulfill its vision & mission, we are committed and dedicated to provide our best effort. Along with these courses, we have very specialized academic platform for the youngsters. Equipped with high commitment, holly mission, super-modern technical know-how, faculty members with world-class scholarship, well-thought out intensive syllabus, and conducive environment, named TARBIYAH ONLINE MADRASAH, is the best platform for proper and pious up-keeping of your golden child. We use the latest technology combined with the latest teaching methods that help you quickly and effectively to participate from the comfort of your own homes. We have designed a number of different Quran Learning courses where you can choose any kind of course according to your child’s interest.</p>

        </div>
        </div>
    </>
  )
}

export default AboutTarbiyah